<script>
export default {
    name: 'IconComment',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-comment"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 8v48L44 44H8V8h48zM34 29H16v4h18v-4zm14-10H16v4h32v-4z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
